import { DisponibilityChoice, DogAffinityChoice } from '@/data'
import { AppDispatch } from '@/store'
import * as BasicAuthServiceHelper from '@/modules/Auth/BasicAuthServiceHelper'
import { ConfigurationTypes } from './ConfigurationReducer'

import { DogBreed } from '@/dataV3/Animal/DogBreed'
import { DogSize } from '@/dataV3/Animal/DogSize'
import { DisponibilityChoices, DogAffinityChoices, DogBreeds, DogSizes } from './apiTypes'
import { AnimalSpecies } from '@/dataV3/Animal/AnimalSpecies'

/* *******************************
   DOG BREEDS
 ******************************* */

export const dispatchGetDogBreedsAsync =
  (dispatch: AppDispatch) =>
  async (species?: AnimalSpecies): Promise<DogBreed[]> => {
    const speciesToFetch = species ? [species] : [AnimalSpecies.dog, AnimalSpecies.cat, AnimalSpecies.nac]

    await Promise.all(
      speciesToFetch.map(async (specie) => {
        try {
          const { items } = await BasicAuthServiceHelper.getAllHydraCollectionPagesV2Async<DogBreeds.Response>(
            DogBreeds.Route(specie),
            { cache: 'no-store' },
          )
          switch (specie) {
            case AnimalSpecies.dog:
              dispatch({ type: ConfigurationTypes.UpdateDogBreeds, payload: items })
              break
            case AnimalSpecies.cat:
              dispatch({ type: ConfigurationTypes.UpdateCatBreeds, payload: items })
              break
            case AnimalSpecies.nac:
              dispatch({ type: ConfigurationTypes.UpdateNacBreeds, payload: items })
              break
          }
        } catch (error) {
          console.warn(`Cannot GET Breeds for ${specie}`, error.message)
          const emptyBreeds: DogBreed[] = []
          switch (specie) {
            case AnimalSpecies.dog:
              dispatch({ type: ConfigurationTypes.UpdateDogBreeds, payload: emptyBreeds })
              break
            case AnimalSpecies.cat:
              dispatch({ type: ConfigurationTypes.UpdateCatBreeds, payload: emptyBreeds })
              break
            case AnimalSpecies.nac:
              dispatch({ type: ConfigurationTypes.UpdateNacBreeds, payload: emptyBreeds })
              break
          }
        }
      }),
    )

    return []
  }

/* *******************************
   DOG SIZES
 ******************************* */

export const dispatchGetDogSizesAsync = (dispatch: AppDispatch) => async (): Promise<DogSize[]> => {
  let dogSizes: DogSize[]

  try {
    ;({ items: dogSizes } = await BasicAuthServiceHelper.getAllHydraCollectionPagesV2Async<DogSizes.Response>(
      DogSizes.Route,
      { cache: 'no-store' },
    ))
  } catch (error) {
    console.warn('Cannot GET DogSizes', error.message)
    dogSizes = []
  }

  dispatch({ type: ConfigurationTypes.UpdateDogSizes, payload: dogSizes })

  return dogSizes
}

/* *******************************
   DISPONIBILITY CHOICES
 ******************************* */

export const dispatchGetDisponibilityChoicesAsync =
  (dispatch: AppDispatch) => async (): Promise<DisponibilityChoice[]> => {
    let choices: DisponibilityChoice[]

    try {
      ;({ items: choices } =
        await BasicAuthServiceHelper.getAllHydraCollectionPagesV2Async<DisponibilityChoices.Response>(
          DisponibilityChoices.Route,
          { cache: 'no-store' },
        ))
    } catch (error) {
      console.warn('Cannot GET DisponibilityChoices', error.message)
      choices = []
    }

    dispatch({ type: ConfigurationTypes.UpdateDisponibilityChoices, payload: choices })

    return choices
  }

/* *******************************
   DOG AFFINITY CHOICES
 ******************************* */

export const dispatchGetDogAffinityChoicesAsync = (dispatch: AppDispatch) => async (): Promise<DogAffinityChoice[]> => {
  let choices: DogAffinityChoice[]

  try {
    ;({ items: choices } = await BasicAuthServiceHelper.getAllHydraCollectionPagesV2Async<DogAffinityChoices.Response>(
      DogAffinityChoices.Route,
      { cache: 'no-store' },
    ))
  } catch (error) {
    console.warn('Cannot GET DogAffinityChoices', error.message)
    choices = []
  }

  dispatch({ type: ConfigurationTypes.UpdateDogAffinityChoices, payload: choices })

  return choices
}

/* *******************************
  GET ALL
 ******************************* */

export const dispatchRefreshAllConfigurationAsync = (dispatch: AppDispatch) => async () => {
  return Promise.all([
    dispatchGetDogBreedsAsync(dispatch)(), // Remove species parameter to fetch all
    dispatchGetDogSizesAsync(dispatch)(),
    dispatchGetDisponibilityChoicesAsync(dispatch)(),
    dispatchGetDogAffinityChoicesAsync(dispatch)(),
  ])
}
